<template>
  <div id="app_layout">
    <appHeader></appHeader>
    <el-container class="mainWrapper">
      <sliderBar></sliderBar>
      <el-main class="mainContent">
        <!--<router-view />-->
        <!-- <div class="breadCrumb"></div> -->
        <TagsView></TagsView>
        <el-card class="layout_card">
          <!-- <TagsView></TagsView> -->
          <keep-alive :include="cachedViews">
            <router-view/>
          </keep-alive>
        </el-card>
      </el-main>
    </el-container>
    <!-- <appFooter :style="{'position': 'fixed', 'bottom': '0px'}"></appFooter> -->
  </div>
</template>

<script>
import appHeader from './commonHeader'
// import appFooter from 'views/firmiana/home/footer'
/*import sliderBar from './Sidebar.vue'
// import {mapGetters} from 'vuex'*/
import { mapGetters } from 'vuex'
import TagsView from './TagsViews'
import sliderBar from './sliderWhich'
export default {
  name: 'appLayout',
  components: {
    sliderBar,
    appHeader,
    TagsView
  },
  computed: {
    ...mapGetters([
      'cachedViews'
    ])
  }
}
</script>

<style lang="scss" scoped>
#app_layout {
  height: 100%;
  .mainWrapper {
    height: 100%;
    .sideContent {
      height: 100%;
    }
    .el-main {
      padding: 0px;
    }
    .mainContent {
      padding: 10px 20px;
      height: calc(100vh - 60px);
      .layout_card {
        min-height: calc(100vh - 140px);
      }
      .el-breadcrumb {
        padding-left: 20px;
        line-height: 40px;
      }
      .breadCrumb {
        width: 100%;
        height: 30px;
        line-height: 30px;
        border-radius: 3px;
        color: #fff;
        background: lightgray;
      }
    }
  }
}
</style>
<style lang="scss">
#app_layout {
  .el-card {
    // border-top: none;
    margin-top: -2px;
    margin-left: -1px;
    box-shadow: 0 0 0 0;
    border-top-left-radius: 0px;
  }
  .el-card__body {
    padding: 10px 20px 0;
  }
  .el-menu{
    border-right: none;
  }
  .sideContent {
    .el-submenu__icon-arrow {
      right: 10px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/firmiana/layout/index.vue